import React, { useState, useEffect } from 'react';
import { Project } from '../services/projectService';
import ProjectCard from '../components/ProjectCard';
import { useAuth } from '../context/AuthContext';
import LoadingSpinner from '../components/LoadingSpinner';
import './ProjectsPage.css';

const ProjectsPage = () => {
  const [projects, setProjects] = useState<Project[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const { api, roles } = useAuth();

  const fetchProjects = async () => {
    try {
      // Re-using the api instance from context is better than a separate service
      const response = await api.get('/proyectos/');
      setProjects(response.data);
    } catch (error) {
      console.error('Failed to fetch projects:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchProjects();
  }, []);

  const handleCreateProject = async () => {
    const newProjectName = prompt('Ingrese el nombre del nuevo proyecto:');
    if (newProjectName) {
      try {
        const response = await api.post('/proyectos/', { name: newProjectName });
        setProjects([...projects, response.data]);
      } catch (error) {
        alert('Error al crear el proyecto. Asegúrese de tener los permisos necesarios.');
      }
    }
  };

  const handleAnalyze = async (projectId: number) => {
    // Optimistically update the UI to show the analysis has started
    setProjects(projects.map(p => 
      p.id === projectId ? { ...p, state: 'analyzing' } : p
    ));

    try {
      await api.post(`/proyectos/${projectId}/analyze`);
      // Optionally, show a success notification
      alert(`Análisis para el proyecto ${projectId} iniciado.`);
      // The project state is already 'analyzing'. The backend will eventually change it to 'completed'.
      // We might want to re-fetch projects here or after a delay to get the final status.
    } catch (error) {
      console.error('Failed to start analysis:', error);
      alert('Error al iniciar el análisis.');
      // Revert the UI change on error
      fetchProjects();
    }
  };

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="projects-page">
      <header className="page-header">
        <h1>Mis Proyectos</h1>
        {(roles.includes('admin') || roles.includes('consultor')) && (
          <button onClick={handleCreateProject} className="create-button">
            Crear Nuevo Proyecto
          </button>
        )}
      </header>

      {projects.length === 0 ? (
        <div className="no-projects-placeholder">
          <h2>No hay proyectos todavía</h2>
          <p>¡Cree su primer proyecto para comenzar!</p>
        </div>
      ) : (
        <div className="projects-grid">
          {projects.map((project) => (
            <ProjectCard 
              key={project.id} 
              project={project}
              onAnalyze={handleAnalyze} 
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ProjectsPage; 